'use client';

import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  LinkList,
  LinkListItem,
} from 'design-react-kit';

type HeaderUserMenuProps = {
  username: string;
  logoutHref: string;
};

/** Intranet top-bar user menu; same dropdown as the language switcher. */
export default function HeaderUserMenu({
  username,
  logoutHref,
}: HeaderUserMenuProps) {
  return (
    <div className="header-user-menu">
      <Dropdown className="top-slim-dropdown">
        <DropdownToggle caret color="primary" title={username}>
          <span className="label header-user-menu__name">{username}</span>
        </DropdownToggle>
        <DropdownMenu>
          <LinkList>
            <LinkListItem inDropdown href={logoutHref}>
              Esci
            </LinkListItem>
          </LinkList>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
